import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { logout, restoreSession } from "../features/auth/authSlice";
import type { RootState, AppDispatch } from "../app/store";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    dispatch(restoreSession())
      .unwrap()
      .catch(() => dispatch(logout()))
      .finally(() => setChecking(false));
  }, [dispatch]);

  if (checking) return null;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default ProtectedRoute;
